Simple component to show a div when you hover something. Pass a #content slot with the
tooltip content and a default slot for the element to watch for hovers.
<template>
	<Popper
		hover
		arrow
		placement='top'>
		<slot></slot>
		<template #content>
			<slot name='content'></slot>
		</template>
	</Popper>
</template>

<script lang="ts">
import Popper from 'vue3-popper'
import { defineComponent } from 'vue'
import CheckableButton from '@/components/CheckableButton.vue'

export default defineComponent({
	name: "ToolTip",
	components: {
		CheckableButton,
		Popper,
	},
})

</script>
